import Config from '@common/config/config'
import { ddayjs } from '@dt/fe-utils'
import { memberMobx } from '@mobxStore'
import { getPlatform } from '@utils'
import axios from 'axios'
import { pick } from '@dt/fe-utils/dist/lodash'
import { MemberApi } from '.'
import env from '../env'

export default class PayAPI {
  static listPaymentTypesStoreV2 (params) {
    return axios.post(env.PAYING + '/payment/listPaymentTypesStoreV2', params)
  }
  static authCreditCard (params) {
    return axios.post(env.PAYING + '/payment/authCreditCard', params)
  }
  static deleteCreditCard (params) {
    return axios.post(env.PAYING + '/payment/deleteCreditCard', params)
  }
  static listCreditCard (params) {
    if (env.env === 'pro' && !boJudge?.checkKey('creditCard')) {
      return []
    }
    return axios.post(env.PAYING + '/payment/listCreditCard', params)
  }
  static pay (params) {
    return axios.post(env.PAYING + '/payment/pay', params)
  }
  static batchPay (params) {
    return axios.post(env.PAYING + '/payment/batchPay', params)
  }
  static listPaymenAccountExt (params) {
    return axios.post(env.PAYING + '/payment/listPaymenAccountExt', params)
  }
  static async getCompliancePolicy () {
    const data = await axios.post(env.POSMOBILE + '/brandExt/getBrandExt', {
      attr_name: 'mobile_compliance_policy'
    }) as any
    const { attrValue } = data.result.content
    if (attrValue) {
      return JSON.parse(attrValue)
    } else {
      return ''
    }
  }
  static async applePayMerchantValidate (params) {
    return axios.post(env.PAYING + '/payment/applePayMerchantValidate', params)
  }
  static preByPrepayCreateId (prepayCreateId: string) {
    return axios.post(env.PAYING + '/payment/preByPrepayCreateId', { prepayCreateId })
  }
  static preByOrdersId (ordersId: string) {
    return axios.post(env.PAYING + '/payment/preByOrdersId', { ordersId })
  }
  static cancelPay (prepayCreateId: string, clientNumber: string, ordersId: string) {
    return axios.post(env.ORDERJMOBILE + '/cancelPay', { prepayCreateId, clientNumber, ordersId })
  }
  static lockPreCreate (prepayCreateId: string, ordersId, clientNumber: string, strictMode: boolean) {
    return axios.post(env.PAYING + '/payment/lockPreCreate', { prepayCreateId, ordersId, clientNumber, strictMode })
  }
  static unLockPreCreate (prepayCreateId: string, ordersId: string, clientNumber: string) {
    return axios.post(env.PAYING + '/payment/unLockPreCreate', { prepayCreateId, ordersId, clientNumber })
  }
  static ListCreditCardForMemberManagement (memberId: number) {
    return axios.post(env.PAYING + '/payment/ListCreditCardForMemberManagement', { memberId })
  }
  static deleteCreditCardForMemberManagement (memberId: number, creditCardMaskedPan: string) {
    return axios.post(env.PAYING + '/payment/deleteCreditCardForMemberManagement', { memberId, creditCardMaskedPan })
  }
  static async openIdErrorDingTalkSend (ordersId: string, openId?: string) {
    const memberResult = await MemberApi.getMemeberInfo()
    const { isWeixinBrower, isAlipay } = getPlatform()

    const message = [
      '### openId问题报警',
      `环境:${env.env}`,
      `> ordersId:${ordersId}`,
      `> 发生场景: ${isAlipay ? '支付宝' : (isWeixinBrower ? '微信网页' : '微信小程序')}`,
      `> memberMobx.thirdAuthInfo: ${memberMobx.thirdAuthInfo}`,
      `> memberDetail返回:${JSON.stringify(memberResult)}`,
      `> config:${JSON.stringify(pick(Config, ['STOREID', 'BRANDID', 'TABLECODE', 'openId', 'gopenId', 'token']))}`,
      `> payController.payOpenId:${openId}`,
      '> 发生时间: ' + ddayjs().format('YYYY-MM-DD HH:mm:ss'),
    ]

    const url = 'https://logproxy.eshine.cn/oapi.dingtalk.com/robot/send?access_token=75b902009918fd376de8223176fc673bfc2195f8b3955e8c881924cb14ffd542'

    try {
      fetch(url, {
        method: 'post',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          msgtype: 'markdown',
          'markdown': {
            title: 'openId出错',
            text: message.join(' \n\n ')
          }
        })

      })
    } catch (e) {
      console.log(e)
    }
  }

  /** 预验券 三方券 */
  static getCouponDetail (params: any) {
    return axios.post(`${env.PAYING}/payment/getCouponDetailV2`, params).then((res: any) => {
      return res
    }).catch((err) => err)
  }
  /** 批量预验券 三方券 */
  static getCouponDetailList (params: any) {
    return axios.post(`${env.PAYING}/payment/getCouponDetailList`, params).then((res: any) => {
      return res
    }).catch((err) => err)
  }

  static async queryOrdersByPrepayId (params) {
    return axios.post(env.ORDER + '/getOrdersByPaymentPrepayId', params)
  }
  // 获取附加费方案
  static querySurchargeConfigByStoreId (storeId: number) {
    return axios.post(`${env.PAYING}/payment/querySurchargeConfigByStoreId`, { storeId })
  }
  // 获取附加费方案
  static queryRechargeSurchargeConfigByBrandId (brandId?: number) {
    return axios.post(`${env.PAYING}/payment/queryRechargeSurchargeConfigByBrandId`, { brandId })
  }
}
